import {inject, Injectable} from '@angular/core';
import {StaticTable} from '../static.table';
import {PrProcessReport} from '../../interfaces/process-reports/pr-process-report';
import {db} from '../db.service';
import {SyncTable} from '../sync.table';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {WmWoundDocumentation} from '../../interfaces/wound-management/wm-wound-documentation';
import {WmWoundDocumentationFactory} from '../../factories/wound-management/wm-wound-documentation-factory';
import {WmWoundDocumentationEntriesTable} from '../wound-management/wm-wound-documentation-entries.table';
import {WmWoundImagesTable} from '../wound-management/wm-wound-images.table';
import {PrProcessReportFactory} from '../../factories/process-reports/pr-process-report-factory';


@Injectable({
  providedIn: 'root'
})
export class PrProcessReportsTable extends SyncTable<PrProcessReport> {
  constructor() {
    super(db.prProcessReports);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<PrProcessReport>({
        api: ['pr-process-reports'],
        fromObject: PrProcessReportFactory.fromObject,
        toRemote: PrProcessReportFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<PrProcessReport[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   *
   * @param userId
   */
  public async getByUserId(userId: number): Promise<PrProcessReport[]> {
    return this.table.where('userId').equals(userId).toArray();
  }

}
